
import { Typography, Stack } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from "react-slick";
import { Helmet } from 'react-helmet-async';


const Product = () => {

  let settings = {
    dots: true,
    infinite: false,
    speed: 200,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      {breakpoint: 900, settings: { slidesToShow: 3 }},
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
        { breakpoint: 360, settings: { slidesToShow: 1 } }
    ]
  };


  return (
  <>

      

       <Helmet>
        <title>
          Our Products | Fresh Flowers, Wholesale & Retail,  Vases & Gifts in Ikoyi, Lagos – Rutchina Flowers
        </title>

        <meta
          name="description"
          content="Explore Rutchina Flowers' wide range of fresh flowers, luxury bouquets, flower vases, teddy bears, chocolates, cakes, wrappers and gift items in Ikoyi, Lagos. Wholesale and retail available with fast delivery."
        />

        <meta
          name="keywords"
          content="fresh flowers Ikoyi, flower shop Ikoyi Lagos, buy flowers Lagos, flower vases Lagos, teddy bears Lagos, wholesale flowers Nigeria, bouquet shop Ikoyi, flower gift items Lagos"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Fresh Flowers & Gift Items in Ikoyi, Lagos | Rutchina Flowers"
        />
        <meta
          property="og:description"
          content="Shop fresh flowers, vases, teddies, chocolates, cakes & gift items in Ikoyi, Lagos. Wholesale and retail flower supply available."
        />
        <meta property="og:type" content="website" />

        {/* Local SEO */}
        <meta name="geo.placename" content="Ikoyi, Lagos" />
        <meta name="geo.region" content="NG-LA" />
      </Helmet>


    <div  id='product'>
      <Stack style={{  backgroundColor:  'rgba(255, 255, 0, 0.3)', 
    }} >
       

        <Stack className='product-text-stack'>

          <Typography variant="h3"
            sx={{
              justifyContent: 'center', position: 'relative',
              display: 'flex', color: 'black', mt:3,
              mb: 10,
              '&::after': {
                content: '""',
                display: 'block',
                width: '15%', // Adjust to control underline length
                height: '1px', // Thickness of the underline
                backgroundColor: 'rgb(244,198,48)', // Underline color
                position: 'absolute',
                bottom: '-2px', // Controls gap between text and underline
                left: '43%', // Centers the underline
              }
            }} style={{ fontFamily: 'Playfair Display, serif',
              fontSize: '30px',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '2px',
             
              textAlign: 'center',
              textShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',
              
              
              }} data-aos='slide-up' >
            Our Products
          </Typography>

          <div data-aos="slide-up" className='shadow-md xs:rounded md:rounded-full bg-white py-6 px-6 mb-6  md:mb-20 flex flex-col md:flex-row md:mx-16 gap-4 md:justify-center items-center '>
            <p className='basis-1/2 tracking-wide'> 
            At Rutchina Flowers, we provide both wholesale and retail flower deals, catering to all
            your floral needs. Our collection includes a wide variety of fresh flowers, elegant vases,
            adorable teddies, stylish gift boxes, and much more—perfect for every occasion.💐✨
            </p>

            <button className='shadow-md rounded basis-1/3 font-semibold text-4xl uppercase font-momo px-4 py-2 h-16 hover:bg-yellow-100' id="p-butt"   
            style={{border:"3px solid rgb(152, 143, 56)"}}>
              <a href='http://wa.me/message/XHB2H2ZDZ2A6C1' target='_blank' rel="noopener noreferrer"  style={{color:'rgb(107, 105, 38)'}} id="p-butt-a">
                Place Order
              </a>
          </button>
          </div>

         
        </Stack>

        <Stack  style={{}} >

<div className='ml-5 mb-24 '>
       <Slider {...settings}>
         {ProductData.map((data1) => (
           <div  className='card shadow-md overflow-hidden max-w-[170px] rounded-full' >
<LazyLoadImage
  src={data1.img}
  alt={data1.seoAlt}
  title={data1.seoTitle}
  effect="blur"
  loading="lazy"
  className="w-60 object-cover relative h-60"
  width="240"
  height="240"
/>
             <div className='text-center p-3' style={{backgroundColor:'rgb(179, 168, 66)'}}>
               <span className='font-bold pr-2 text-xl text-center'>{data1.name}</span>
             </div>
           </div>
         ))}
       </Slider>

</div>
 
      </Stack>

       
      </Stack>
       
    </div>
  </>
  )
}


const ProductData = [
  {
    img: require('./assets/images/flowerGrid.webp'),
    name: 'Fresh Flowers',
    seoAlt: 'Buy fresh flowers in Ikoyi Lagos - Rutchina Flowers Shop',
    seoTitle: 'Fresh Flowers in Ikoyi Lagos'
  },
  {
    img: require('./assets/images/vaseGrid.webp'),
    name: 'Flower Vases',
    seoAlt: 'Flower vases for bouquets in Ikoyi Lagos - Rutchina Flowers',
    seoTitle: 'Flower Vases Lagos'
  },
  {
    img: require('./assets/images/boxGrid.webp'),
    name: 'Gift Boxes',
    seoAlt: 'Luxury gift boxes for flowers in Ikoyi Lagos',
    seoTitle: 'Gift Boxes for Flowers Lagos'
  },
  {
    img: require('./assets/images/Wrappers.webp'),
    name: 'Bouquet Wrappers',
    seoAlt: 'Bouquet wrappers and floral packaging in Ikoyi Lagos',
    seoTitle: 'Bouquet Wrappers Lagos'
  },
  {
    img: require('./assets/images/editPillows.webp'),
    name: 'Gift Pillows',
    seoAlt: 'Romantic gift pillows for flower gifting in Lagos',
    seoTitle: 'Gift Pillows Lagos'
  },
  {
    img: require('./assets/images/teddy.webp'),
    name: 'Teddy Bears',
    seoAlt: 'Buy teddy bears with flowers in Ikoyi Lagos',
    seoTitle: 'Teddy Bears Lagos'
  },
  {
    img: require('./assets/images/chocolate.webp'),
    name: 'Chocolates',
    seoAlt: 'Chocolates and flower gift combos in Ikoyi Lagos',
    seoTitle: 'Chocolates for Gifting Lagos'
  },
  {
    img: require('./assets/images/cake.webp'),
    name: 'Cakes',
    seoAlt: 'Birthday and celebration cakes with flowers in Ikoyi Lagos',
    seoTitle: 'Cakes for Celebrations Lagos'
  }
];

export default Product;